module.exports = __webpack_public_path__ + "static/monster-looking-over-bd3a503252d707c0e0c8b4a428e5a234.png";